module.exports = __webpack_public_path__ + "img/student.a9fd7b0f.svg";